module.exports = __webpack_public_path__ + "static/media/Combusken_gaussian2.9741b62e.png";